// import React from "react";
// import { Link } from "react-router-dom";
// import {
//   FaBuilding,
//   FaUsers,
//   FaHandshake,
//   FaGavel,
//   FaLaptopCode,
//   FaLeaf,
// } from "react-icons/fa";

// const PracticeAreas = () => {
//  const COLORS = {
//   bgPrimary: "#0A0A0A",   // Deep Black
//   bgSecondary: "#121212", // Slightly Lighter Black
//   gold: "#A47148",        // Premium Brown (instead of gold)
//   textLight: "#EAEAEA",
// };

//   const practices = [
//     {
//       title: "Civil Matters",
//       desc: "Expert handling of property disputes, contracts, and ownership conflicts.",
//       icon: <FaBuilding />,
//       link: "/services/civil-cases",
//     },
//     {
//       title: "Criminal Law",
//       desc: "Strategic defense in bail, trial, and white-collar crimes.",
//       icon: <FaGavel />,
//       link: "/services/criminal-cases",
//     },
//     {
//       title: "Matrimonial",
//       desc: "Confidential support in divorce and child custody.",
//       icon: <FaUsers />,
//       link: "/services/matrimonial-Cases",
//     },
//     {
//       title: "Commercial",
//       desc: "Business advisory and regulatory compliance.",
//       icon: <FaHandshake />,
//       link: "/services/commercial-disputes",
//     },
//     {
//       title: "Cyber Law",
//       desc: "Protection against fraud and data theft.",
//       icon: <FaLaptopCode />,
//       link: "/services/cyber-cases",
//     },
//     {
//       title: "Environmental",
//       desc: "Compliance and NGT litigation support.",
//       icon: <FaLeaf />,
//       link: "/services/environmental-matters",
//     },
//   ];

//   return (
//     <section className="py-24 px-6 md:px-16 lg:px-32">
//       <div className="max-w-7xl mx-auto">

//         {/* Header */}
//         <div className="mb-16 text-center">
//           <span className="uppercase tracking-widest text-[10px] font-bold block mb-4" style={{ color: COLORS.gold }}>
//             Our Specializations
//           </span>
//           <h2 className="text-4xl md:text-5xl font-serif font-bold leading-tight" style={{ color: "Black" }}>
//             Areas of <span className=" font-light opacity-60">Legal</span> Excellence
//           </h2>
//         </div>

//         {/* Cards Grid */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//           {practices.map((item, idx) => (
//             <Link
//               key={idx}
//               to={item.link}
//               className="group relative bg-[#13293D] rounded-3xl p-8 md:p-10 flex flex-col justify-between overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
//             >
//               {/* Faint background icon */}
//               <div
//                 className="absolute -bottom-6 -right-6 text-7xl opacity-5 group-hover:opacity-10 transition-all duration-500"
//                 style={{ color: COLORS.gold }}
//               >
//                 {item.icon}
//               </div>

//               <div className="relative z-10">
//                 {/* Icon Circle */}
//                 <div
//                   className="w-14 h-14 flex items-center justify-center rounded-xl mb-6 text-2xl transition-all duration-500 group-hover:bg-white/10 border border-white/20"
//                   style={{ color: COLORS.gold }}
//                 >
//                   {item.icon}
//                 </div>

//                 {/* Title */}
//                 <h3 className="text-2xl font-bold mb-3 text-white">{item.title}</h3>

//                 {/* Description */}
//                 <p className="text-gray-400 text-lg leading-relaxed group-hover:text-gray-200 transition-colors">
//                   {item.desc}
//                 </p>
//               </div>

//               {/* Learn More */}
//               <div className="mt-8 flex items-center gap-2 text-xs font-bold uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-all group-hover:translate-y-0 -translate-y-2 text-[#C6A75E]">
//                 Learn More <span className="text-lg">→</span>
//               </div>

//               {/* Hover Top Border */}
//               <div
//                 className="absolute top-0 left-0 h-[2px] w-0 group-hover:w-full transition-all duration-700"
//                 style={{ backgroundColor: COLORS.gold }}
//               />
//             </Link>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default PracticeAreas;

import React from "react";
import { Link } from "react-router-dom";
import {
  FaBuilding,
  FaUsers,
  FaHandshake,
  FaGavel,
  FaLaptopCode,
  FaLeaf,
} from "react-icons/fa";

const PracticeAreas = () => {
  const practices = [
    {
      title: "Civil Matters",
      desc: "Property disputes, contracts, and ownership conflicts.",
      icon: <FaBuilding />,
      link: "/services/civil-lawyer",
    },
    {
      title: "Criminal Law",
      desc: "Strategic defense in bail, trials, and white-collar crimes.",
      icon: <FaGavel />,
      link: "/services/criminal-lawyer",
    },
    {
      title: "Matrimonial",
      desc: "Confidential support in divorce and custody matters.",
      icon: <FaUsers />,
      link: "/services/matrimonial-lawyer",
    },
    {
      title: "Company Dispute Lawyer",
      desc: "Expert legal representation and strategic advice for corporate and business disputes.",
      icon: <FaHandshake />,
      link: "/services/company-dispute-lawyer",
    },
    {
      title: "Cyber Law",
      desc: "Protection against cyber fraud and data theft.",
      icon: <FaLaptopCode />,
      link: "/services/cyber-crime-lawyer",
    },
    {
      title: "Environmental",
      desc: "NGT litigation and environmental compliance.",
      icon: <FaLeaf />,
      link: "/services/environmental-lawyer",
    },
  ];

  return (
    <section className="relative py-24 px-6 lg:px-20 overflow-hidden">

      {/* 🔥 PREMIUM BROWN BACKGROUND */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#FAF9F6] via-[#F3EDE7] to-[#E8DED2]" />

      {/* subtle brown pattern */}
      <div className="absolute inset-0 opacity-[0.05] bg-[radial-gradient(circle_at_1px_1px,#A47148_1px,transparent_0)] bg-[size:22px_22px]" />

      {/* content */}
      <div className="relative max-w-7xl mx-auto">

        {/* HEADER */}
        <div className="mb-20 text-center">
          <p className="text-sm uppercase tracking-[0.4em] text-[#A47148] mb-4">
            Our Expertise
          </p>

          <h2 className="text-4xl md:text-5xl font-semibold text-black">
            Legal Practice Areas
          </h2>
        </div>

        {/* CARDS */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">

          {practices.map((item, idx) => (
            <Link
              key={idx}
              to={item.link}
              className="group relative p-8 rounded-2xl bg-white/85 backdrop-blur-md border border-[#E5DED6] hover:border-[#A47148] hover:shadow-xl hover:-translate-y-2 transition-all duration-500 overflow-hidden"
            >

              {/* hover gradient */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500 bg-gradient-to-br from-[#A47148]/10 to-transparent" />

              {/* icon */}
              <div className="w-14 h-14 flex items-center justify-center rounded-xl mb-6 text-xl bg-[#A47148]/10 text-[#A47148] group-hover:scale-110 transition">
                {item.icon}
              </div>

              {/* title */}
              <h3 className="text-xl font-semibold mb-3 text-black group-hover:translate-x-1 transition">
                {item.title}
              </h3>

              {/* desc */}
              <p className="text-sm text-gray-600 leading-relaxed">
                {item.desc}
              </p>

              {/* bottom */}
              <div className="mt-6 flex items-center justify-between">
                <span className="text-sm text-[#A47148] ">
                  Learn More →
                </span>
                <div className="h-[2px] w-0 group-hover:w-10 bg-[#A47148] transition-all duration-500" />
              </div>

            </Link>
          ))}

        </div>
      </div>
    </section>
  );
};

export default PracticeAreas;